const _ = require('lodash')

module.exports = meshParams => { //TODO: this logic should be in carmi
    const rotatedComponents = []
    const wedges = []
    const children = _.get(meshParams, 'structure.children[0].children[0].children', [])
    children.forEach(comp => {
        if (comp.id.includes('rotated-wrapper')) {
            rotatedComponents.push(...comp.children.map(child => child.id))
        } else if (comp.id.includes('wedge')) {
            wedges.push(comp.id)
        }
    })
    return {
        styles: meshParams.styles,
        wedges,
        rotatedComponents
    }
}
